var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 20.3L16.3 14.9C17.4 13.5 18 11.8 18 10C18 7.9 17.2 5.9 15.7 4.3C14.1 2.8 12.1 2 10 2C7.9 2 5.9 2.8 4.3 4.3C2.8 5.9 2 7.9 2 10C2 12.1 2.8 14.1 4.3 15.7C5.9 17.2 7.9 18 10 18C11.8 18 13.5 17.4 14.9 16.3L20.3 21.7L21.7 20.3ZM10 16C8.4 16 6.9 15.4 5.8 14.2C4.6 13.1 4 11.6 4 10C4 8.4 4.6 6.9 5.8 5.8C6.9 4.6 8.4 4 10 4C11.6 4 13.1 4.6 14.2 5.8C15.4 6.9 16 8.4 16 10C16 11.6 15.4 13.1 14.2 14.2C13.1 15.4 11.6 16 10 16Z",
    fill: "#1460AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.89ffd7bfd1e160db49a8edce3b445c32.svg";
export { ForwardRef as ReactComponent };